import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import {
  DropdownMenu,
  type DropdownItem,
} from "@repo/ui/Dropdown/dropdownMenu";
import { Size } from "@repo/ui/helpers/helpers";
import { IconDots, IconFlagCheck, IconPencil } from "@tabler/icons-react";
import type { FC } from "react";
import { MenuTrigger } from "react-aria-components";

export interface CoachingMoreMenuProps {
  /** Whether the current week already has a manager note (flips the item label). */
  hasCurrentNote: boolean;
  /** Whether next week already has a manager-set goal (flips the item label). */
  hasNextGoal: boolean;
  /** Hidden when there is no current coaching week to attach a note to. */
  onAddNote?: () => void;
  onSetNextGoal: () => void;
}

/** The "…" menu next to the coaching-period selector, for editors/reviewers. */
export const CoachingMoreMenu: FC<CoachingMoreMenuProps> = (props) => {
  const { hasCurrentNote, hasNextGoal, onAddNote, onSetNextGoal } = props;

  const items: DropdownItem[] = [
    ...(onAddNote
      ? [
          {
            icon: <IconPencil className="size-4" />,
            label: hasCurrentNote
              ? "Edit this week's note"
              : "Add a note this week",
            onClick: onAddNote,
          },
        ]
      : []),
    {
      icon: <IconFlagCheck className="size-4" />,
      label: hasNextGoal ? "Edit next week's goal" : "Set next week's goal",
      onClick: onSetNextGoal,
    },
  ];

  return (
    <MenuTrigger>
      <IconButton
        accessibleLabel="Coaching goal actions"
        size={Size.MEDIUM}
        variant={ButtonVariant.Secondary}
        icon={<IconDots className="size-4" />}
      />
      <DropdownMenu items={items} />
    </MenuTrigger>
  );
};
